// extracted by mini-css-extract-plugin
module.exports = {"container":"container-XzykO","bottom":"bottom-8cYHn","link":"link-1-7Az","arrowWrapper":"arrowWrapper-2eV6L","servicesIcons":"servicesIcons-2FZZG"};